import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { FieldType } from '@ngx-formly/core';
import { ContextService, LayoutInterface } from '../../context.service';
import { SendMessageDialogComponent } from './send-message-dialog.component';

@Component({
    selector: 'mutara-layout-dialog',
    template: `
    <mat-dialog-actions class='mutara-subheader' align="end">
        <button mat-flat-button (click)="showMessage()" color="primary">Contact {{delegateName}}</button>
        <button mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
    </mat-dialog-actions>
    <mat-dialog-content>
        <mutara-layout [dialogData]='data'></mutara-layout>
    </mat-dialog-content>
`,
    styleUrls: ['./layout-dialog.component.scss'],
    standalone: false
})

export class LayoutDialogComponent extends FieldType implements OnInit {

    layout: LayoutInterface | undefined;
    delegateName: string = 'Applicant';

    /**
     * Class implementation
     * @param contextSettings 
     * @param dialogRef 
     */
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private contextSettings: ContextService,
        private dialogRef: MatDialogRef<LayoutDialogComponent>,
        private dialog: MatDialog
    ) {
        super();
    }

    ngOnInit() {
        this.delegateName = this.dialogRef.componentInstance.data.delegateName;
        // this.contextSettings.subscribeTo("closeDelegate", {
        //     next: (closeDialog : ) => {
        //         if (closeDialog) {
        //             //     this.close();
        //         }
        //     }
        // });
    }
    showMessage() {
        this.dialog.open(SendMessageDialogComponent,
            {
                disableClose: false,
                autoFocus: true,
                // panelClass: 'custom-dialog',
                width: '85%',
                height: 'auto',
                hasBackdrop: true,
                data: {
                    personId: this.dialogRef.componentInstance.data.personId,
                    delegateName: this.dialogRef.componentInstance.data.delegateName
                },
                role: 'dialog'
            });
    }
    close() {
        //    this.contextSettings.setDelegateLayout(this.contextSettings.revertDelegate);
        this.dialogRef.close();
    }
}
